import React from 'react'
import FieldGroup from '../FieldGroup'
import PropTypes from 'prop-types';

class EmailAddressInput extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    validation: PropTypes.shape({ 
      isInvalid: PropTypes.bool, 
      message: PropTypes.string 
    }),
    setEmail: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string
  };

  constructor (props) {
    super(props)

    this.state = {
      touched: false
    }

    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
  if (this.props.value) {
    const validationResult = this.getvalidationstate(true, this.props.value)
    this.props.setEmail(validationResult, this.props.value)
  }
}

componentDidUpdate(prevProps) {
  if (this.props.value !== prevProps.value && this.props.value) {
    const validationResult = this.getvalidationstate(true, this.props.value)
    this.props.setEmail(validationResult, this.props.value)
  }
}


  handleFocus (event) {
    this.setState({ touched: true })
  }

  handleChange (event) {
    let touched = this.state.touched
    let value = event.target.value
    var validationResult = this.getvalidationstate(this.state.touched, value)
    this.props.setEmail(validationResult, value)
  }

  handleBlur (event) {
    let touched = this.state.touched
    let value = event.target.value
    var validationResult = this.getvalidationstate(this.state.touched, value)
    this.props.setEmail(validationResult, value)
  }

  getvalidationstate (touched, value) {
    if (!touched) {
      return {
        isInvalid: false,
        message: null,
        valid: false
      }
    }

    if (!value) {
      return {
        isInvalid: true,
        message: 'Please enter your email address',
        valid: false
        
      }
    }

    if (value.length < 3 || value.indexOf('@') < 0) {
      return {
        isInvalid: true,
        message: 'Email address is invalid',
        pristine: false,
        valid: false
      }
    }

    if (value.length > 320) {
      return {
        isInvalid: true,
        message: 'Email address exceeds max length (320)',
        pristine: false,
        valid: false
      }
    }

    let endingCharacter = value.slice(-1)
    if (endingCharacter === '.' || endingCharacter === '@') {
      return {
        isInvalid: true,
        message: 'Email address contains invalid characters',
        pristine: false,
        valid: false
      }
    }

    return {
      isInvalid: false,
      message: null,
      pristine: false,
      valid: true
    }
  }

  render () {
    const { validation ={}} = this.props
    const { message =''} = validation
    const handleChange = this.handleChange
    const handleBlur = this.handleBlur
    const handleFocus = this.handleFocus
    const placeholder = this.props.placeholder
    return <FieldGroup
      label={this.props.label}
      type='email'
      required
      isInvalid={validation.isInvalid}
      value={this.props.value}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      message={message}
      onChange={handleChange} />
  }
}

export default EmailAddressInput
